<template>
  <v-container
    v-if="
      !goodCauseLoading &&
      !currentProfileLoading &&
      currentProfile.status == 'Approved'
    "
    fill-height
    fluid
  >
    <v-layout justify-center wrap>
      <v-container grid-list-xl class="pageContent">
        <v-layout row wrap align-center>
          <v-flex xs12 sm6 class="text-xs-center text-sm-left">
            <div class="headline font-weight-thin">
              Our UpstreamNZ Impact Report
            </div>
            <div class="headline font-weight-thin" style="color: #4cc7e8">
              {{ currentProfile.company }}
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout
              row
              class="text-xs-center text-sm-right"
              style="width: 100%"
            >
              <v-spacer />
              <v-layout column class="pt-2">
                <v-layout
                  row
                  class="heading text-xs-center text-sm-right font-weight-medium"
                >
                  <v-spacer />
                  <v-img
                    :src="require('../assets/Values/UpstreamNZ Badges-05.png')"
                    class="joinOptionCards"
                    style="cursor: pointer; width: 100px; max-height: 150px"
                    contain
                  />
                  <v-spacer class="hidden-md-and-up" />
                </v-layout>
              </v-layout>
              <v-spacer class="hidden-md-and-up" />
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap class="mt-4">
              <v-flex xs12 sm6 lg4>
                <v-img :src="currentProfile.imageUrl" width="100%" />
              </v-flex>
              <v-flex xs12 sm6 lg8>
                <div class="headline heading">Who we are</div>
                <div class="body-1" style="padding-bottom: 20px">
                  {{ currentProfile.whoWeAre }}
                </div>
                <!-- <div class="headline heading">Why we care</div>
                <div class="body-1" style="padding-bottom: 20px;">{{ currentProfile.whyWeCare }}</div> -->
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            v-if="currentProfile.chosenGoodCause"
            xs12
            class="elevation-1"
            style="background: white; padding: 20px; margin-bottom: 25px"
          >
            <v-layout row wrap>
              <v-flex xs12 sm6 lg4 align-center justify-center>
                <div style="text-align: center; margin: auto">
                  <div class="headline heading" style>
                    Our Chosen Good Cause
                  </div>
                </div>
                <v-card class="elevation-0" style="margin: auto; width: 60%">
                  <div style="width: 100%">
                    <v-img
                      :src="chosenGoodCause[0].imageUrl"
                      width="80%"
                      style="margin: auto"
                    >
                      <v-container fill-height fluid>
                        <v-layout fill-height>
                          <v-flex xs12 align-end flexbox />
                        </v-layout>
                      </v-container>
                    </v-img>
                  </div>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 lg8>
                <div class="headline heading">Most recent impact story</div>
                <br />
                <div class="body-1" style="padding-bottom: 20px">
                  {{ currentProfile.recentImpactStory }}
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- buyer section -->
          <v-flex
            xs12
            class="elevation-2"
            style="background: white; padding: 20px 30px"
            v-if="currentProfile.buyerSelected"
          >
            <div class="headline sectionHeader">
              <template>Our UpstreamNZ Impact As A Buyer</template>
            </div>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">We've Used</div>
                  <div class="impactCardBody impactCardImageWrapper">
                    <div class="mr-3">
                      {{ currentProfile.impactBusinessSupliers }}
                    </div>
                    <v-img
                      class="impactCardImage"
                      :src="
                        require('../assets/Values/Approved_Supplier-04.png')
                      "
                      contain
                    />
                  </div>
                  <div class="impactCardFooter">
                    {{ currentProfile.buyersSlogan }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">Which Generated</div>
                  <v-card-title class="impactCardBodyTitle">
                    <div class="title impactCardBody">
                      <v-icon style="font-size: 55pt; color: #4cc7e8"
                        >mdi-charity</v-icon
                      >
                      ${{ currentProfile.contributionsGenerated }}
                    </div>
                  </v-card-title>
                  <div class="impactCardFooter">
                    {{ currentProfile.contributionsGeneratedSlogan }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">Which Meant</div>
                  <v-card-title class="impactCardBodyTitle">
                    <div class="impactCardBody title">
                      {{ communityHourCalc }} hrs
                    </div>
                  </v-card-title>
                  <div class="impactCardFooter">
                    {{ currentProfile.communityHoursSlogan }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <hr style="max-width: 90%; margin: auto" />
            <v-layout row wrap v-if="currentProfile.tradiesSelected">
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">We Are A</div>
                  <v-img
                    :src="require('../assets/Values/UpstreamNZ Badges-04.png')"
                    style="
                      cursor: default;
                      height: 185px;
                      margin-top: 25px;
                      margin-bottom: 25px;
                    "
                    contain
                  />
                  <div class="impactCardFooter">
                    {{ currentProfile.tradieSlogan }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">That Diverted</div>
                  <v-card-title class="impactCardBodyTitle">
                    <div class="impactCardBody title">
                      {{ currentProfile.tradieStat1 }}
                    </div>
                  </v-card-title>
                  <div class="impactCardFooter">
                    {{ currentProfile.tradieMessage1 }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">From Using</div>
                  <v-card-title class="impactCardBodyTitle">
                    <div class="impactCardBody title">
                      {{ currentProfile.tradieStat2 }}
                    </div>
                  </v-card-title>
                  <div class="impactCardFooter">
                    {{ currentProfile.tradieMessage2 }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- supplier section -->
          <v-flex
            xs12
            class="elevation-2"
            style="background: white; padding: 20px 30px"
            v-if="currentProfile.supplierSelected"
          >
            <div class="headline sectionHeader">
              <template>Our UpstreamNZ Impact As A Supplier</template>
            </div>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">We've Supplied</div>
                  <v-card-title class="impactCardBodyTitle">
                    <div class="title impactCardBody">
                      {{ currentProfile.impactBusinessSales }} SALES
                    </div>
                  </v-card-title>
                  <div class="impactCardFooter">
                    {{ currentProfile.suppliersSlogan }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">Which Generated</div>
                  <v-card-title class="impactCardBodyTitle">
                    <div class="title impactCardBody">
                      <v-icon style="font-size: 55pt; color: #4cc7e8"
                        >mdi-charity</v-icon
                      >
                      ${{ currentProfile.contributionsGeneratedSupplier }}
                    </div>
                  </v-card-title>
                  <div class="impactCardFooter">
                    {{ currentProfile.contributionsGeneratedSloganSupplier }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm4>
                <div style="text-align: center">
                  <div class="impactCardTitle">Which Meant</div>
                  <v-card-title class="impactCardBodyTitle">
                    <div class="impactCardBody title">
                      {{ communityHourCalcSupplier }} hrs
                    </div>
                  </v-card-title>
                  <div class="impactCardFooter">
                    {{ currentProfile.communityHoursSloganSupplier }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <hr style="max-width: 90%; margin: auto" />
          </v-flex>
        </v-layout>
        <!--<pre>{{ currentProfile }}</pre>-->
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      customRoutes: {
        coffee: "inrvq2lcoW1PV30PsdVH",
        power: "z14vz7TiRWXNLRnKBbFD",
      },
      communityHours: 0,
    }),
    computed: {
      ...mapGetters({
        user: "user",
        goodCauseLoading: "goodCauses/loading",
        currentProfileLoading: "impactBusinesses/loading",
        currentProfile: "impactBusinesses/currentProfile",
        keywords: "impactBusinesses/keywords",

        goodCauses: "goodCauses/list",
      }),
      chosenGoodCause: function () {
        let goodCause = this.goodCauses.filter(
          (gc) => gc.name == this.currentProfile.chosenGoodCause
        );
        return goodCause;
      },
      communityHourCalc: function () {
        let hours = this.currentProfile.contributionsGenerated * 0.0567;
        hours = Math.round(hours);
        if (hours > this.communityHours) {
          return hours;
        } else {
          return this.communityHours;
        }
      },
      communityHourCalcSupplier: function () {
        let hours = this.currentProfile.contributionsGeneratedSupplier * 0.0567;
        hours = Math.round(hours);
        if (hours > this.communityHours) {
          return hours;
        } else {
          return this.communityHours;
        }
      },
    },
    mounted() {
      this.$store.dispatch("goodCauses/loadAll");
    },
    created() {
      this.$nextTick(function () {
        this.$store.dispatch(
          "impactBusinesses/loadProfileByKeyword",
          this.$route.params.keyword
        );
      });
    },
    methods: {},
  };
</script>

<style>
  .heading {
    color: #4dc8ed;
  }

  .application {
    background-color: white !important;
  }

  .sectionHeader {
    border-bottom: 1px solid #4dc8ed;
    color: #4dc8ed;
  }

  .nl2br {
    white-space: pre;
  }

  .impactCardBody {
    font-weight: bold !important;
    font-family: "Aleo" !important;
    font-size: 55pt !important;
    color: #4cc7e8;
    margin-bottom: 0 !important;
    text-align: center;
    width: 100%;
  }

  .impactCardBodyTitle {
    height: 235px;
  }

  .impactCardTitle {
    font-weight: bold !important;
    font-family: "Aleo" !important;
    font-size: 2rem !important;
    color: #58595b;
  }

  .impactCardImageWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }

  .impactCardImage {
    cursor: default;
    height: 160px;
    max-width: 160px;
    margin-top: 21px;
    margin-bottom: 21px;
    display: inline-block;
  }

  #silentbox-overlay__description {
    color: #000;
    background: rgb(77, 200, 237);
    padding: 5px;
    border: 1px solid white;
    font-size: 14pt !important;
  }

  @media only screen and (min-width: 1264px) {
    .pageContent {
      max-width: 1200px;
    }
  }

  @media only screen and (max-width: 1264px) {
    .pageContent {
      max-width: 1200px;
    }
  }
</style>
